import type { LockedPositionStore, StakingPositionStore, UnwindingPositionStore } from "@/hooks";

export const isLockedPosition = (
    value: LockedPositionStore | StakingPositionStore | UnwindingPositionStore,
): value is LockedPositionStore => "lockDuration" in value;

export const isStakedPosition = (value: LockedPositionStore | StakingPositionStore): value is StakingPositionStore =>
    "stakedBalance" in value;
